import { gql } from '@apollo/client';
/**
 * @const ImportSaleItemRelationsMutation
 * @since 1.0.0
 */
export const ImportSaleItemRelationsMutation = gql `
  mutation ImportSaleItemRelationsMutation($input: ImportSaleItemRelationsInput!) {
    importSaleItemRelations(input: $input)
  }
`;
